module.exports = __webpack_public_path__ + "img/HANSSEN_m.f23fec8c.png";